module.exports = "<div class=\"container\">\n    <h3>Bedankt,</h3>\n    <div class=\"mt-4\">\n        Zodra de betalling ontvangen is, ontvang je een email ter bevestiging. <br>\n        Deze email komt van <strong>system@wringers-bertem.be</strong>.<br>\n        Let op, deze kan wel in je spam terechtkomen.\n      \n    </div>\n\n\n\n    <img class=\"mt-3\" style=\"height: 300pt;\" src=\"/assets/images/generals/ThankYou.jpg\" alt=\"\">\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/payment-redirect/payment-redirect.component.html
// module id = 515
// module chunks = 0